import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';


import { SubmitButton, CloseButton } from '../..';
import { LOADING_PROP_TYPE, SEND_REMINDER_EMAIL, sendReminderEmail, displayToaster } from '../../../modules';
import './SendForReminder.scss';


class SendForReminder extends React.Component {
  componentDidUpdate(prevProps) {
    const { loading } = this.props;
    if (loading[SEND_REMINDER_EMAIL] === 'complete'
      && prevProps.loading[SEND_REMINDER_EMAIL] === 'loading') {
      this.props.onClose();
      this.props.displayToaster(
        'success',
        <FormattedMessage
          id="REMINDER_SENT"
          values={{
            employeeName: this.props.selectedDocument.employeeName,
          }}
          defaultMessage="REMINDER_SENT_DEFAULT"
        />,
        'app',
        5000,
        true,
      );
    }
  }

  submitRequest() {
    this.props.sendReminderEmail(
      this.props.selectedDocument.companyId,
      this.props.selectedDocument.employeeId,
      this.props.selectedDocument.id,
    );
  }


  render() {
    const {
      onClose,
      selectedDocument: { title, employeeName },
      loading,
    } = this.props;

    const isLoading = loading[SEND_REMINDER_EMAIL] === 'loading';

    return (
      <div className="container px-4 py-4 rounded">
        {/* we use a negative margin on the header so that the bottom border extends all the way to the edge of the container */}
        <div className="modal-header pt-1 pb-3 mx-n4 px-4">
          <h4 id="send-reminder-header" className="mb-0">
            <FormattedMessage id="SEND_REMINDER" />
          </h4>
          <CloseButton onClick={onClose} />
        </div>
        <div>
          <p className="pt-3 pb-2 mb-2">Send <span id="employee-name">{employeeName}</span> a reminder to sign:</p>
          <ul className="pl-3">
            <li>
              {title}
            </li>
          </ul>
        </div>

        <div className="d-flex flex-row-reverse">
          <SubmitButton
            onSubmit={() => this.submitRequest()}
            defaultLabel="SEND_REMINDER"
            submittingLabel="SENDING"
            disabled={isLoading}
            submitting={isLoading}
          />
          <Button className="mr-3" color="default" onClick={onClose}>
            <FormattedMessage id="CANCEL" />
          </Button>
        </div>


      </div>);
  }
}

SendForReminder.defaultProps = {
  selectedDocument: {},
};

SendForReminder.propTypes = {
  displayToaster: PropTypes.func.isRequired,
  sendReminderEmail: PropTypes.func.isRequired,
  loading: LOADING_PROP_TYPE.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedDocument: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    companyId: PropTypes.string,
    employeeId: PropTypes.string,
    employeeName: PropTypes.string,
  }),
};

export default connect((state) => {
  const {
    resources: {
      docs: {
        selectedDocument,
      },
    },
    appState: { loading },
  } = state;
  return {
    selectedDocument,
    loading,
  };
}, {
  sendReminderEmail,
  displayToaster,
})(hot(module)(SendForReminder));



// WEBPACK FOOTER //
// ./src/components/Forms/SendForReminder/SendForReminder.jsx